module.exports = __webpack_public_path__ + "static/media/banner3.e3ea1774.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner3.jpg
// module id = 344
// module chunks = 0